import { ConfirmationService } from 'primeng/api';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationBaseService {
  constructor(public confirmationService: ConfirmationService) {}
}
